import { render, staticRenderFns } from "./ListRequests.vue?vue&type=template&id=5b3a37ee&scoped=true"
import script from "./ListRequests.vue?vue&type=script&lang=js"
export * from "./ListRequests.vue?vue&type=script&lang=js"
import style0 from "./ListRequests.vue?vue&type=style&index=0&id=5b3a37ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a37ee",
  null
  
)

export default component.exports